/*
 * Top level module for handling all things administrative.  Will be added to as
 * we move functionality from the existing Admin site to this site.
 */

define([
  "marionette",
  "backbone",
  "jquery",
  "configuration/properties",
  "messaging/messenger",
  "modules/admin/adminView",
  "modules/admin/userAdmin/userAdminModule",
], function (Marionette, Backbone, $, Properties, Messenger, AdminView, UserAdminModule) {
  "use strict";

  const AdminController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "admin";
      this.region = options.region;
      this.router = new Router({
        controller: this,
      });
      this._setUpVents();
    },
    show: function () {
      const kbId = Messenger.reqres.request("active:kb");
      Backbone.history.navigate(kbId + "/admin");
      document.title = $.t("admin.title.adminTitle") + " - " + Properties.applicationName;

      this.layout = new AdminView.adminLayout();
      this.userAdmin = this.addSubModule(
        new UserAdminModule({ region: this.layout.adminMainArea }),
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );

      this.showRegion(this.layout);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:admin",
        function () {
          this.show();
        },
        this,
      );
    },
    _showSubViews: function () {
      this.userAdmin.show();
    },
    _route: function (kbId) {
      Messenger.command.execute("set:active:kb", kbId);
      this.show();
    },
  });

  const Router = Marionette.AppRouter.extend({
    appRoutes: {
      ":kbId/admin": "_route",
    },
  });

  return AdminController;
});
